import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesStateService {
  private readonly hasUnsavedChangesSubject = new BehaviorSubject<boolean>(false);

  readonly hasUnsavedChanges$ = this.hasUnsavedChangesSubject.asObservable();

  hasUnsavedChanges(): boolean {
    return this.hasUnsavedChangesSubject.value;
  }

  setHasUnsavedChanges(hasUnsavedChanges: boolean): void {
    if (this.hasUnsavedChangesSubject.value === hasUnsavedChanges) {
      return;
    }

    this.hasUnsavedChangesSubject.next(hasUnsavedChanges);
  }
}